const DEFAULT_FLAG_MESSAGE_TIMEOUT = 5000;

function showFlagMessage({
                           name = '',
                           message = '',
                           success = false,
                           warning = false,
                           error = false,
                           classString = ''
                         }) {
  const flagMessage = document.createElement('axs-flag-message');

  flagMessage.name = name;
  flagMessage.success = success;
  flagMessage.warning = warning;
  flagMessage.error = error;

  if (classString !== '') {
    flagMessage.classList.add(classString);
  }

  flagMessage.innerHTML = message;

  document.body.appendChild(flagMessage);
  return flagMessage;
}

export {showFlagMessage, DEFAULT_FLAG_MESSAGE_TIMEOUT};
